module.exports = __webpack_public_path__ + "img/404-text.241106e8.svg";